import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import IconPattern from '@mlb/react-patterns/components/Icon';
import Skeleton from '@mlb/react-patterns/components/Skeleton';
import COLORS from '@mlb/react-patterns/style/universal.color';

import AspectRatioCard, { Container } from '../AspectRatioCard';
import ScalableText from '../ScalableText';

const BASE_WIDTH = 80;
const BASE_HEIGHT = 77;
const ICON_WIDTH = 24;
const ICON_MARGIN_BOTTOM = 6;
const TEXT_HEIGHT = 18;

const Card = styled(AspectRatioCard)`
    ${Container} {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

const Content = styled.div`
    max-width: 130px;
`;

const Category = styled(ScalableText)`
    text-align: center;
    line-height: ${TEXT_HEIGHT}px;
    font-weight: 600;
`;

const Icon = styled(IconPattern)`
    display: block;
    width: ${ICON_WIDTH * 100 / BASE_WIDTH}%;
    height: ${ICON_WIDTH * 100 / BASE_HEIGHT}%;
    margin: 0 auto ${ICON_MARGIN_BOTTOM * 100 / BASE_WIDTH}%;
    stroke: none;
`;

const TeamCategoryCard = (props) => {

    const {
        category,
        iconName,
        loading,
        as,
        ...otherProps
    } = props;

    return (
        <Card
            aspectRatio={`${BASE_WIDTH}:${BASE_HEIGHT}`}
            forwardedAs={as}
            {...otherProps}
        >
            { loading ? (
                <Skeleton margin={0} />
            ) : (
                <Content>
                    <Icon name={iconName} fill={COLORS.mlbWhite} role="img" />
                    <Category
                        viewBoxWidth={BASE_WIDTH}
                        viewBoxHeight={TEXT_HEIGHT}
                        fontSize={'11px'}
                    >
                        {category}
                    </Category>
                </Content>
            )}
        </Card>
    );

};

TeamCategoryCard.propTypes = {
    category: PropTypes.string,
    iconName: PropTypes.string,
    loading: PropTypes.bool,
};

TeamCategoryCard.defaultProps = {
    loading: false,
};

export default TeamCategoryCard;
